define(["dojo/i18n", "/local/buildagent/work/bab00163f105c0e5/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"/local/buildagent/work/bab00163f105c0e5/target/debug/2P/derived/ui/mw-keybindings/l10n/nls/keyBindings.js?absMid=mw-keybindings/l10n/nls/keyBindings"
], function(loader, runner) {
   return runner(loader, "mw-keybindings/l10n/nls/keyBindings", __webpack_require__.dj.c(), true);
});